module.exports = function() {
  return new Worker(__webpack_public_path__ + "255da25e5083d79ff4ee.worker.js");
};